(function () {
  "use strict";

  a3_cabin_reports.controller("RerunLotteryWarningModalCtrl", RerunLotteryWarningModalCtrl);

  function RerunLotteryWarningModalCtrl($scope, $uibModalInstance) {
    $scope.ok = function () {
      $uibModalInstance.close(true);
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss("cancel");
    };
  }
})();